import { render, staticRenderFns } from "./IgPaymentMethodInfo.vue?vue&type=template&id=327acb65&scoped=true&"
import script from "./IgPaymentMethodInfo.vue?vue&type=script&lang=js&"
export * from "./IgPaymentMethodInfo.vue?vue&type=script&lang=js&"
import style0 from "./IgPaymentMethodInfo.vue?vue&type=style&index=0&id=327acb65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327acb65",
  null
  
)

export default component.exports